import React from 'react'

const ContactUs = () => {
  return (<>
    <div className='p-5 text-center bg-light'><h1 className="mb-3">ContactUs</h1></div>
    <form className='w-100 embed-responsive embed-responsive-16by9'>
    <p>&nbsp;</p>
    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfhL_A44OjIWdiAs04Uve1bnk4OL5wzNFe3dqpTRPwJEh5t7w/viewform?embedded=true" className="w-100 ">Loading…</iframe></form></>
  )
}

export default ContactUs;